




















































import Vue from 'vue';
enum STATE {
  loading = 'loading',
  loaded = 'loaded',
  start = 'start',
  error = 'error'
}
export default Vue.extend({
  props: {
    message1: { type: String, default: 'Creating your project…' },
    message2: { type: String, default: 'Provisioning resources…' },
    message3: { type: String, default: 'Finishing up…' },
    title: { type: String, default: '' },
    value: {
      type: [Number, String],
      default: 0
    },
    rotate: {
      type: [Number, String],
      default: 0
    },
    error: { type: Boolean, default: false }
  },
  data: () => ({
    radius: 10,
    interval: 0
  }),
  computed: {
    circumference(): number {
      return 2 * Math.PI * this.radius;
    },

    normalizedValue(): number {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return parseFloat(this.value as string);
    },

    state(): string {
      if (this.error) {
        return STATE.error;
      } else if (this.normalizedValue === 100) {
        return STATE.loaded;
      } else if (this.normalizedValue === 0) {
        return STATE.start;
      } else if (this.normalizedValue > 1) {
        return STATE.loading;
      } else {
        return STATE.error;
      }
    },

    // strokeDashArray(): number {
    //   return Math.round(this.circumference * 1000) / 1000;
    // },
    strokeDashArray(): number {
      //
      return (this.normalizedValue / 100) * 360;
    },
    strokeDashOffset(): string {
      return ((100 - this.normalizedValue) / 100) * this.circumference + 'px';
    },

    svgStyles(): object {
      return {
        // transform: `translate(-50%, -50%)  rotate(${Number(this.rotate)}deg)`,
        // 'stroke-dasharray': `0, ${this.strokeDashArray}, 9999`
        // transform: 'translate(-50%, -50%) rotate(90deg)'
        left: '50%',
        position: 'absolute',
        top: '50%',
        fill: 'none',
        stroke: '#fff',
        // /* stroke-dasharray: 0, 314.159265359, 9999; */
        // /* transform: translate(-50%, -50%) rotate(-90deg); */
        transition: 'stroke-dasharray 0.4s ease',
        'z-index': '1000'
      };
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    // this.interval = setInterval(() => {
    //   if (this.value > 100) {
    //     // return (this.value = 0);
    //     // this.state = STATE.loaded
    //     clearInterval(this.interval);
    //   }
    //   this.value += 2;
    // }, 200);
  },
  watch: {
    // value(val) {
    //   if (val > 100) {
    //     this.state = STATE.loaded;
    //   } else if (val > 0 && val < 100) {
    //     this.state = STATE.loading;
    //   } else {
    //     this.state = STATE.error;
    //   }
    // }
  }
});
